module.exports = __webpack_public_path__ + "static/media/SERIE6.dde9e68b.jpg";